import { MediaConfigWithSide } from '../../types';
import { Media } from '../ui/Media';
import { BulletPoints } from './BulletPoints';
import styles from './BulletPointsWithMedia.module.css';
import { clsx } from 'clsx';

type BulletPointsWithMediaProps = {
  bulletPoints: string[];
  resultText: string;
  media: MediaConfigWithSide;
};

export const BulletPointsWithMedia = ({ bulletPoints, resultText, media }: BulletPointsWithMediaProps) => {
  return (
    <div
      className={clsx(styles.bulletPointsWithMediaLayout, {
        [styles.bulletPointsWithMediaLayoutMediaRight]: media.side === 'right',
      })}>
      <div className={styles.bulletPointsMedia}>
        <Media mediaConfig={media} className={styles.mediaContent} />
      </div>
      <div style={{ flex: 1 }}>
        <BulletPoints resultText={resultText} bulletPoints={bulletPoints} />
      </div>
    </div>
  );
};
